module.exports = __webpack_public_path__ + "img/fx.cbf460cb.png";